export default "__VITE_ASSET__QNjHVZ$3__"